import { render, staticRenderFns } from "./AddStartups.vue?vue&type=template&id=d7655d4a&"
import script from "./AddStartups.vue?vue&type=script&lang=js&"
export * from "./AddStartups.vue?vue&type=script&lang=js&"
import style0 from "./AddStartups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports